import { RouterModule, Routes } from '@angular/router';
import { AdminGuard } from '../services/admin.guard';
import { AuthGuard } from '../shared-components/ng-login/auth/auth-guard.service';
import { DashboardComponent } from './dashboard/dashboard.component';
import { GrantManagementComponent } from './grant-management/grant-management.component';
import { HelpCenterComponent } from './help-center/help-center.component';
import { LoginComponent } from './login/login.component';
import { LogoutBeforeSelector } from '../services/logout-before-selector.guard';
import { MainComponent } from './main/main.component';
import { NgModule } from '@angular/core';
import { ResetPasswordComponent } from './user/reset-password/reset-password.component';
import { RoleGuard } from '../shared-components/ng-login/auth/auth-role.service';
import { Roles } from '../utils/enums';
import { SupportGuard } from '../services/support.guard';
import { UserActivateAccountComponent } from './user/user-activate-account/user-activate-account.component';
import { UserForgotPasswordComponent } from './user/user-forgot-password/user-forgot-password.component';
import { UserManagementComponent } from './user/user-management/user-management.component';
import { VerticalSelectorComponent } from './vertical-selector/vertical-selector.component';
import { WelcomeVideoManagementComponent } from './welcome-video-management/welcome-video-management.component';

const adminRoles = [Roles.ADMIN, Roles.SUPPORT];
const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    data: { roles: adminRoles },
    canActivate: [AuthGuard, RoleGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: '/dashboard' },
      {
        path: 'dashboard',
        component: DashboardComponent
      },
      {
        path: 'help-center',
        component: HelpCenterComponent,
        canActivate: [AdminGuard],
      },
      {
        path: 'user-management',
        component: UserManagementComponent,
        canActivate: [SupportGuard],
      },
      {
        path: 'welcome-video-management',
        component: WelcomeVideoManagementComponent,
        canActivate: [AdminGuard]
      },
      // {
      //   path: 'insights',
      //   component: InsightsComponent
      // },
      {
        path: 'grant-management',
        component: GrantManagementComponent,
        canActivate: [AdminGuard],
      },
    ]
  },
  {
    path: 'vertical-selector',
    component: VerticalSelectorComponent,
    canActivate: [LogoutBeforeSelector]
  },
  {
    path: 'login',
    component: LoginComponent
  },
  {
    path: 'set-password/:token/:language/:subdomain',
    component: ResetPasswordComponent
  },
  {
    path: 'activate-account/:token/:language/:subdomain',
    component: UserActivateAccountComponent
  },
  {
    path: 'forgot-password',
    component: UserForgotPasswordComponent
  },
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
